"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _ramda = require("ramda");

var _connectedReactRouter = require("connected-react-router");

var _reactRouterDom = require("react-router-dom");

var _hooks = require("@alycecom/hooks");

var _queryString = _interopRequireDefault(require("query-string"));

var _auth = require("../constants/auth.constants");

var _useAuthService2 = require("../hooks/useAuthService");

var _AuthErrorMessage = _interopRequireDefault(require("./AuthErrorMessage"));

var ACTIONS_WITH_LOGOUT = [_auth.AUTH_INVALID_REQUEST, _auth.AUTH_UNAUTHORIZED_CLIENT, _auth.AUTH_ACCESS_DENIED, _auth.AUTH_SERVER_ERROR, _auth.AUTH_INVALID_TOKEN];

var AuthCallback = function AuthCallback() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useLocation = (0, _reactRouterDom.useLocation)(),
      search = _useLocation.search;

  var _useUrlQuery = (0, _hooks.useUrlQuery)(['success', 'error', 'username', 'error_description'], _ramda.identity),
      success = _useUrlQuery.success,
      error = _useUrlQuery.error,
      username = _useUrlQuery.username,
      errorDescription = _useUrlQuery.error_description;

  var nextPath = (0, _react.useMemo)(function () {
    var parsedSearch = _queryString.default.parse(search);

    return parsedSearch.next || '/';
  }, [search]);
  var shouldAutoLogout = (0, _react.useMemo)(function () {
    return ACTIONS_WITH_LOGOUT.includes(error);
  }, [error]);

  var _useAuthService = (0, _useAuthService2.useAuthService)(),
      logoutUrl = _useAuthService.logoutUrl;

  var handleRedirect = (0, _react.useCallback)(function () {
    if (shouldAutoLogout) {
      window.location.href = logoutUrl;
    } else {
      dispatch((0, _connectedReactRouter.push)('/'));
    }
  }, [dispatch, shouldAutoLogout, logoutUrl]);
  var errorTitle = (0, _ramda.propOr)('Unexpected error', error, _auth.AUTH_ERROR_DESCRIPTIONS);

  if (success) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
      to: nextPath
    });
  }

  return /*#__PURE__*/_react.default.createElement(_AuthErrorMessage.default, {
    username: username,
    error: errorTitle,
    errorText: errorDescription,
    shouldAutoLogout: shouldAutoLogout,
    redirect: handleRedirect
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(AuthCallback);

exports.default = _default;